export const Routes = {
  login: '/login',
  workshop: '/talleres',
  comisionist: '/comisionistas',
  comisionistForm: '/comisionistas/form',
  users: '/users',
  providers: '/providers',
  devices: '/devices',
  workshopTypes: '/workshopTypes',
  profile: '/profile',
  help: '/help',
  home: '/home',
  dashboard: '/dashboard',
  systemParameters: '/system-parameters'
} as const;
